import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);


class LooseDiamondPage extends React.Component {

	constructor(props) {
		super(props);
    this.state = {};
	}

	render() {
		return <div className={'LooseDiamondPage pageContent'}>

      <div className='descriptionBlock'>
        <div className='descriptionItem'><span className='descriptionEm'>1.</span> A GIA certified pear shaped diamond weighing 11.71 carats.</div>
        <div className='descriptionItem'><span className='descriptionEm'>2.</span> A brilliant round cut diamond weighing 10.05 carats.</div>
        <div className='descriptionItem'><span className='descriptionEm'>3.</span> A GIA certified internally flawless fancy vivid yellow diamond weighing 13.43 carats.</div>
        <div className='descriptionItem'><span className='descriptionEm'>4.</span> An emerald cut diamond weighing 11.52 carats.</div>
      </div>
		</div>;
	}
}
export default LooseDiamondPage;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const LooseDiamondPageContainer = connect(
  mapStateToProps,
  allActionCreators
)(LooseDiamondPage);


// WEBPACK FOOTER //
// ./src/components/views/page/LooseDiamondPage.jsx